class window.Eyes
    constructor: (
        @Style = 0,
        @ForeColour = "#000", @BackColour = "#fff", @SecondaryColour = @ForeColour,
        @Name = "Eyes"
    ) ->
        # 0=pixels, 1=round
        @G = null

    Add: (parent = 'body', cssObj = null) ->
        $(parent).append("<div id='eyes-div-#{@Name}'><canvas width='60' height='45'>No canvas support.</canvas></div>")
        $("#eyes-div-#{@Name} canvas").css({
            position: 'absolute',
            width: $("#eyes-div-#{@Name} canvas").attr('width'),
            height: $("#eyes-div-#{@Name} canvas").attr('height')
        })
        if cssObj?
            $("#eyes-div-#{@Name} canvas").css(cssObj)
        @G = $("#eyes-div-#{@Name} canvas")[0].getContext("2d")
        @Draw(@GetEyeX(0), @GetEyeY(0) + 5, @GetEyeX(1) - 5, @GetEyeY(1) + 5)
        self = this
        $(document).mousemove((evt) ->
            self.OnMouseMove(evt)
        )
        $(document).mousedown((evt) ->
            self.OnMouseMove(evt)
        )
        $(document).mouseup((evt) ->
            self.OnMouseMove(evt)
        )

    GetLeft: () ->
        $("#eyes-div-#{@Name} canvas").offset().left

    GetTop: () ->
        $("#eyes-div-#{@Name} canvas").offset().top

    GetEyeX: (i) ->
        if i is 0
            @GetLeft() + $("#eyes-div-#{@Name} canvas").attr('width') * 3.5 / 12
        else
            @GetLeft() + $("#eyes-div-#{@Name} canvas").attr('width') * 8.5 / 12

    GetEyeY: (i) ->
        if i is 0
            @GetTop() + $("#eyes-div-#{@Name} canvas").attr('height') * 3.5 / 9
        else
            @GetTop() + $("#eyes-div-#{@Name} canvas").attr('height') * 5.5 / 9

    GetRadius: () ->
        $("#eyes-div-#{@Name} canvas").attr('height') * 2.5 / 9

    OnMouseMove: (evt) ->
        # Get some constants
        r = @GetRadius()
        x0 = @GetEyeX(0)
        y0 = @GetEyeY(0)
        x1 = @GetEyeX(1)
        y1 = @GetEyeY(1)
        s = $("#eyes-div-#{@Name} canvas").attr('width') / 12
        # Calculate the first eyeball position
        xDir = evt.pageX - x0
        yDir = evt.pageY - y0
        d = Math.sqrt(xDir * xDir + yDir * yDir)
        if d > r - s
            xDir *= (r - s) / d
            yDir *= (r - s) / d
            x0 = x0 + xDir
            y0 = y0 + yDir
        else
            x0 = evt.pageX
            y0 = evt.pageY
        # Calculate the second eyeball position
        xDir = evt.pageX - x1
        yDir = evt.pageY - y1
        d = Math.sqrt(xDir * xDir + yDir * yDir)
        if d > r - s
            xDir *= (r - s) / d
            yDir *= (r - s) / d
            x1 = x1 + xDir
            y1 = y1 + yDir
        else
            x1 = evt.pageX
            y1 = evt.pageY
        # Draw the eyes with the pupils at the right locations
        @Draw(x0, y0, x1, y1)

    Draw: (x0, y0, x1, y1) ->
        @G.clearRect(0, 0, $("#eyes-div-#{@Name} canvas").attr('width'), $("#eyes-div-#{@Name} canvas").attr('height'))
        s = $("#eyes-div-#{@Name} canvas").attr('width') / 12
        if @Style is 0
            # Draw background
            @FillSquare(6 * s, 3 * s, 5 * s, 5 * s, @BackColour)
            @FillSquare(s, s, 5 * s, 5 * s, @BackColour)
            #Second eye
            @FillSquare(7 * s, 2 * s, 4 * s, s)
            @FillSquare(6 * s, 8 * s, 5 * s, s)
            @FillSquare(11 * s, 3 * s, s, 5 * s)
            @FillSquare(6 * s, 3 * s, s, s)
            @FillSquare(5 * s, 7 * s, 2 * s, s)
            @FillSquare(10 * s, 3 * s, s, s)
            @FillSquare(10 * s, 7 * s, s, s)
            # First eye
            @FillSquare(s, 0, 5 * s, s)
            @FillSquare(0, s, s, 5 * s)
            @FillSquare(s, 6 * s, 5 * s, s)
            @FillSquare(6 * s, s, s, 5 * s)
            @FillSquare(s, s, s, s)
            @FillSquare(s, 5 * s, s, s)
            @FillSquare(5 * s, s, s, s)
            @FillSquare(5 * s, 5 * s, s, s)
            # Second eyeball
            if x1 <= @GetEyeX(1)
                if y1 >= @GetEyeY(1)
                    @FillSquare(7 * s, 5 * s, 2 * s, 2 * s)
                else
                    @FillSquare(7 * s, 4 * s, 2 * s, 2 * s)
            else
                if y1 >= @GetEyeY(1)
                    @FillSquare(8 * s, 5 * s, 2 * s, 2 * s)
                else
                    @FillSquare(8 * s, 4 * s, 2 * s, 2 * s)
            # First eyeball
            if x0 >= @GetEyeX(0)
                if y0 >= @GetEyeY(0)
                    @FillSquare(3 * s, 3 * s, 2 * s, 2 * s)
                else
                    @FillSquare(3 * s, 2 * s, 2 * s, 2 * s)
            else
                if y0 >= @GetEyeY(0)
                    @FillSquare(2 * s, 3 * s, 2 * s, 2 * s)
                else
                    @FillSquare(2 * s, 2 * s, 2 * s, 2 * s)
        if @Style is 1
            # Second eye
            @FillCircle(8.5 * s, 5.5 * s, 2.9 * s, @BackColour)
            @DrawCircle(8.5 * s, 5.5 * s, 2.9 * s, s)
            # First eye
            @FillCircle(3.5 * s, 3.5 * s, 2.9 * s, @BackColour)
            @DrawCircle(3.5 * s, 3.5 * s, 2.9 * s, s)
            # Eyeballs
            @FillCircle(x1 - @GetLeft(), (y1 - @GetTop()), s)
            @FillCircle(x0 - @GetLeft(), (y0 - @GetTop()), s)
            # Eye lashes
            @G.beginPath()
            @G.lineWidth = 1
            @G.strokeStyle = @SecondaryColour
            @G.arc(25, 8, 10, 5.4, 0, false)
            @G.stroke()
            @G.beginPath()
            @G.arc(44, 16, 10, 4, 4.9, false)
            @G.stroke()

    DrawCircle: (x, y, r, w, colour = @ForeColour) ->
        @BaseCircle(x, y, r)
        @G.strokeStyle = colour
        @G.lineWidth = w
        @G.stroke()

    FillCircle: (x, y, r, colour = @ForeColour) ->
        @BaseCircle(x, y, r)
        @G.fillStyle = colour
        @G.fill()

    BaseCircle: (x, y, r) ->
        @G.beginPath()
        @G.arc(x, y, r, 0, 2 * Math.PI, false)
        @G.closePath()

    FillSquare: (x, y, w, h, colour = @ForeColour) ->
        @G.beginPath()
        @G.fillStyle = colour
        @G.fillRect(x, y, w, h)
        @G.closePath()
